import {IMAGE_URL_PREFIX, INITIAL_PAGE_URL, LOGO_URL_PREFIX,NEWS_URL_PREFIX, isPROD} from "../../Config";
import ReactGA from "react-ga4";
import { useState, useEffect } from "react";

export function handleRefresch(){
    window.location.reload();
    window.scrollTo(0, 0);
}

let MY_WORK_CITY = new Map();
MY_WORK_CITY.set('0', '선택');
MY_WORK_CITY.set('1','베를린');
MY_WORK_CITY.set('2', '프랑크푸르트');
MY_WORK_CITY.set('3', '뮌헨');

//output korean city name
export function getTextWorkCity(cityList, value){
    if(cityList != undefined && cityList != '' && value != '0'){
        let city = cityList.find((city) => Number(city.cityValue) === Number(value));
        return city.cityName === undefined ? "" : city.cityName;
    } else {
        return ""
    }
}

//output German city name
export function getTextWorkCityDe(cityList, value){
    if(cityList != undefined && cityList != '' && value != '0'){
        let city = cityList.find((city) => Number(city.cityValue) === Number(value));
        return city.cityNameDe === undefined ? "" : city.cityNameDe;
    } else {
        return ""
    }
}

let MY_WORK_TIME = new Map();
MY_WORK_TIME.set('0', '선택');
MY_WORK_TIME.set('1', '풀타임');
MY_WORK_TIME.set('2', '파트타임');
MY_WORK_TIME.set('3', '미니잡');
export function getTextWorkTime(value){
    return MY_WORK_TIME.get(value);
}

let MY_VISA_STAT = new Map();
MY_VISA_STAT.set('0', '선택');
MY_VISA_STAT.set('1','학생비자');
MY_VISA_STAT.set('2','워킹홀리데이비자');
MY_VISA_STAT.set('3','취업준비비자');
MY_VISA_STAT.set('4','워킹비자');
export function getTextVisaStat(value){
    return MY_VISA_STAT.get(value);
}

//yyyyMMdd
export function formatDate(date){
    if (date == null) return ''
    return date.slice(0, 10)
}

export function isDatePassed(dateString) {
    const givenDate = new Date(dateString);
    const currentDate = new Date();
    return givenDate < currentDate;
}

export function getFileUrl(fileEntity){
    let restult = ''
    if(fileEntity != null){
        restult =  IMAGE_URL_PREFIX + fileEntity.uniqFileName + fileEntity.fileFormat
    }
    return restult
}

export function getUniqFileUrl(uniqFileName, fileFormat){
    let restult = ''
    if(uniqFileName != null){
        restult =  IMAGE_URL_PREFIX + uniqFileName + fileFormat
    }
    return restult
}

export function getUniqLogoUrl(uniqFileName, fileFormat){
    let restult = ''
    if(uniqFileName != null){
        restult =  LOGO_URL_PREFIX + uniqFileName + fileFormat
    }
    return restult
}

export function getUniqNewsUrl(uniqFileName, fileFormat){
    let restult = ''
    if(uniqFileName != null){
        if(NEWS_URL_PREFIX.includes("localhost")){
            restult =  "https://www.g-workertest.co.kr/news/news_example.png"
        } else {
            restult =  NEWS_URL_PREFIX + uniqFileName + fileFormat
        }
        
    }
    return restult
}

export function getEmptyLogoUrl(){
    return INITIAL_PAGE_URL +  "assets/img/empty_logo.png"
}

export function getIncorrectUrlLogoUrl(){
    //return INITIAL_PAGE_URL +  "assets/img/incorrect_url_logo.png"
    return INITIAL_PAGE_URL +  "assets/img/gworker_logo_wide.png"
}

export function getFileName(fileEntity){
    let restult = ''
    if(fileEntity != null){
        restult =  fileEntity.fileName
    }
    return restult
}

export function lazyReload(){
    setTimeout(function() {
        window.location.reload();
    }.bind(this), 3000)
}

export function getRegTypeBadge(regType){
    if(regType === 0){
        return <><span class="badge bg-secondary">일반</span></>
    } else if(regType === 1){
        return <><span class="badge bg-primary">프리미엄</span></>
    } else {
        return <></>
    }
}

//승인대기, 승인완료, 승인불가
export function getValidObjBadge(validObj){
    if(validObj === 0){
        return <><span class="badge bg-warning">승인대기</span></>
    } else if(validObj === 1){
        return <><span class="badge bg-success">승인완료</span></>
    } else if(validObj === -1){
        return <><span class="badge bg-danger">승인불가</span></>
    } else {
        return <></>
    }
}

export const CONSTRAINED_DETAIL_LENGTH_SMALL = 50
export const CONSTRAINED_DETAIL_LENGTH_LARGE = 65

export function getLimitedDetailText(text){
    // if(text == null){
    //     return "" + "\n\n\n"
    // }
    if (!text) return "";
    
    //let limitedText = text.replace( /(<([^>]+)>)/ig, ' ')
    let limitedText = text.replace(/(<([^>]+)>)/ig, ' ').replace(/\s+/g, ' ').trim();
    let textLength = limitedText.length
    if(textLength > 50){
        limitedText = limitedText.substring(0,50) + "..."
    }

    // console.log(textLength)
    // if(textLength > 90){
    //     limitedText = limitedText.substring(0,90) + " ..."
    // } else if(textLength > 25 && textLength <= 90) {
    //     limitedText = limitedText + "\n\n"
    // } else if(textLength > 0 && textLength <= 25) {
    //     limitedText = limitedText + "\n\n\n"
    // } 
    //console.log(limitedText)
    return limitedText
}

export function getLimitedDetailTextMax(text, maxLength){
    // if(text == null){
    //     return "" + "\n\n\n"
    // }
    if (!text) return "";
    
    //let limitedText = text.replace( /(<([^>]+)>)/ig, ' ')
    let limitedText = text.replace(/(<([^>]+)>)/ig, ' ').replace(/\s+/g, ' ').trim();
    let textLength = limitedText.length
    if(textLength > maxLength){
        limitedText = limitedText.substring(0,maxLength) + "..."
    }

    // console.log(textLength)
    // if(textLength > 90){
    //     limitedText = limitedText.substring(0,90) + " ..."
    // } else if(textLength > 25 && textLength <= 90) {
    //     limitedText = limitedText + "\n\n"
    // } else if(textLength > 0 && textLength <= 25) {
    //     limitedText = limitedText + "\n\n\n"
    // } 
    //console.log(limitedText)
    return limitedText
}

export function constrainedTitle(text, target_length){
    let result_text
    if(text.length > target_length){
        result_text = text.substring(0,target_length) + " ..."
    } else {
        result_text = text
    }
    return result_text
}

export function getLimitedTitleText(text){
    let textLength = text.length
    let limitedText = text == null ? "" : text
    if(textLength > 35){
        limitedText = text.substring(0,35)
    } else {
        limitedText = text
    }
    return limitedText.replace( /(<([^>]+)>)/ig, '')
}

export function convertTitleText(text){
    let textLength = text.length
    //console.log("textLength: " + textLength)
    let addedText = text == null ? "" : text
    if(textLength < 22){
        addedText = text + '\n\n'
    } else {
        addedText = text
    } 
    // else if(textLength > 23 && textLength < 40){
    //     addedText = text + '\n\n'
    // }
    return addedText
}

export function isValidSearchPage(page){
    let result = false
    if(page == null || page == "null" || page == "" || isNaN(page)){
        result = false
    } else {
        result = true
    }
    return result;
}

export function getGeoPosition(latitude, longitude){
    return [Number(latitude), Number(longitude)];
}

export function sendGoogleAnalytics(pathname){
    if(isPROD){
        ReactGA.send({ hitType: "pageview", page: pathname });
    }
}

export function forbiddenContentCopy(){
    //Ctrl + C 방지
    const handleKeyDown = (e) => {
        if (e.ctrlKey && e.key.toLowerCase() === "c") {
            e.preventDefault();
            //alert("Ctrl + C 사용이 금지되어있습니다!");
        }
    };

    //마우스 오른쪽 클릭 방지
    const handleContextMenu = (e) => {
        e.preventDefault();
        //alert("마우스 오른쪽 클릭 사용이 금지되어있습니다!");
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);

    // cleanup
    return () => {
        document.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("contextmenu", handleContextMenu);
    };
}

export function scrollTop(){
     // 페이지 최상단으로 스크롤
    window.scrollTo(0, 0);
}
